import _ from "lodash";
const findGoalById = (goals, selectedId) => {
  for (const goal of goals) {
    if (goal.id === selectedId) {
      return goal;
    }

    for (const task of goal.goalTasks) {
      if (task.id === selectedId) {
        return goal;
      }
    }
  }

  return {};
};

export const getSelectedGoalItem = (data, selectedItemId) => {
  try {
    const studentGoals = _.map(
      _.get(data, "studentGoalsV2.edges", []),
      edge => edge.node
    );

    return findGoalById(studentGoals, selectedItemId);
  } catch (e) {
    return {};
  }
};
